import * as React from 'react';
import { Breadcrumb, IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { ControlIcons } from 'owa-control-icons';
import { FolderBreadcrumb } from '../store/schema/FolderBreadcrumb';
import { getAllBreadcrumbs } from '../selectors/breadcrumbsSelectors';
import { getErrorString, isCreatingFolderRelatedError } from '../selectors/errorSelectors';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';

const styles = require('./FolderSelectorTopPart.scss');

export interface FolderSelectorTopPartProps {
    onBreadcrumbSelected: (selectedBreadcrumb: FolderBreadcrumb) => void;
    headerTitle: () => string;
}

@observer
export class FolderSelectorTopPart extends React.Component<FolderSelectorTopPartProps, {}> {
    render() {
        const { headerTitle } = this.props;
        const errorString = isCreatingFolderRelatedError() ? getErrorString() : null;
        return (
            <div className={styles.container}>
                <div className={styles.headerTitle}>{headerTitle()}</div>
                <div className={styles.breadcrumbsContainer}>
                    <Breadcrumb
                        className={styles.breadcrumbs}
                        styles={{ chevron: styles.breadcrumbChevron }}
                        items={this.getBreadcrumbItems()}
                        maxDisplayedItems={4}
                    />
                </div>
                {errorString && (
                    <div className={styles.errorContainer} data-is-focusable={true}>
                        <Icon className={styles.errorIcon} iconName={ControlIcons.Error} />
                        <span
                            className={styles.errorText}
                            title={errorString}
                            aria-label={errorString}>
                            {errorString}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    private getBreadcrumbItems(): IBreadcrumbItem[] {
        return getAllBreadcrumbs().map(folderBreadcrumb => {
            const breadcrumb: IBreadcrumbItem = {
                key: folderBreadcrumb.key,
                text: folderBreadcrumb.name,
                onClick: () => this.props.onBreadcrumbSelected(folderBreadcrumb),
            };

            return breadcrumb;
        });
    }
}
